var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c(
        "a",
        {
          staticClass: "news-card",
          attrs: {
            href: _vm.data.detailText
              ? _vm.data.detailPageUrl
              : _vm.data.file.link,
            target: _vm.data.detailText ? "_self" : "_blank",
          },
        },
        [
          _c("div", {
            staticClass: "news-card__img",
            style: "background-image: url(" + _vm.imgSrc + ")",
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "news-card__info" },
            [
              _c("date-block", {
                staticClass: "news-card__date",
                attrs: { size: "s", date: _vm.data.activeFrom },
              }),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "news-card__title" },
                [
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.data.name) },
                  }),
                  _vm._v(" "),
                  !_vm.data.detailText
                    ? _c(
                        "tag",
                        {
                          staticClass: "news-card__title-tag",
                          attrs: { theme: "gray-dark", rounded: "" },
                        },
                        [_c("span", [_vm._v("PDF")])]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              (_vm.data.category && _vm.data.category.length) ||
              _vm.data.type.xmlId === "press-releases"
                ? _c(
                    "div",
                    { staticClass: "news-card__tags" },
                    [
                      _vm.data.type.xmlId === "press-releases"
                        ? _c(
                            "tag",
                            {
                              staticClass: "news-card__tag",
                              attrs: { theme: "peach" },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.data.type.value),
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.data.category, function (tag, index) {
                        return _c(
                          "tag",
                          {
                            key: index,
                            staticClass: "news-card__tag",
                            attrs: { theme: "gray" },
                          },
                          [
                            _c("span", {
                              domProps: { innerHTML: _vm._s(tag.value) },
                            }),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }